import * as local from './local/auth';
import * as nodejs from './nodejs/auth';
import * as laravel from './laravel/auth';

import { API_DRIVER as DRIVER } from '../config/app';

const api = {
    local,
    nodejs,
    laravel
};

export const { login, register, renew } = api[DRIVER];
